import { FieldMapping } from '../../dashboard/model/field-mapping';

export class TypeMapping {
    name: string;
    fields: Array<FieldMapping> = [];
    storeSource: boolean = true;
    rollMaxNumRecords: number = 10000000;
    rollKeepSize: number = 20;
    injestionActive: boolean = true;
    constructor() {

    }
}